import { render } from "./BaseImageMessage.vue?vue&type=template&id=cea38e86&scoped=true"
import script from "./BaseImageMessage.vue?vue&type=script&lang=js"
export * from "./BaseImageMessage.vue?vue&type=script&lang=js"

import "./BaseImageMessage.vue?vue&type=style&index=0&id=cea38e86&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea38e86"]])

export default __exports__